import { createStyles, FormControlLabel, makeStyles } from '@material-ui/core';
import React from 'react';
import { Switch } from '../Switch';

const useFormControlLabelStyle = makeStyles(theme =>
    createStyles({
        label: {
            marginLeft: theme.spacing(1),
        },
        root: {
            marginLeft: 0,
        },
    }),
);

export type SwitchWithLabelProps = {
    disabled?: boolean;
    value?: boolean;
    onChange?: (newValue: boolean) => void;
    label: React.ReactNode;
};

export function SwitchWithLabel({ disabled, label, onChange, value }: SwitchWithLabelProps): JSX.Element {
    const classes = useFormControlLabelStyle();
    return (
        <FormControlLabel
            classes={classes}
            control={<Switch checked={value} onChange={event => onChange?.(event.target.checked)} />}
            disabled={disabled}
            label={label}
        />
    );
}
SwitchWithLabel.displayName = 'SwitchWithLabel';
